import styled from 'styled-components';

export const Container = styled.div`
  min-width: 100px;

  span {
    color: ${(props) => props.theme.colors.text.placeholder} !important;
  }
`;


export const Label = styled.div`
  color: ${(props) => props.theme.colors.modalTitleColor};
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
`;
